<template>
    <div class="container">
      <h2>Estadísticas de Tareas</h2>
  
      <!-- Selector para Proyecto Evento -->
      <div class="form-group">
        <label for="proyecto">Selecciona un Proyecto Evento:</label>
        <select v-model="selectedProyectoId" @change="cargarEstadisticas" class="form-select">
          <option v-for="proyecto in proyectos" :key="proyecto.id" :value="proyecto.id">
            {{ proyecto.nombre }}
          </option>
        </select>
      </div>
  
      <!-- Gráfico de Barras para Costo Total -->
      <h3>Costo Total</h3>
      <canvas id="graficoCosto"></canvas>
  
      <!-- Gráfico de Barras para Total de Horas -->
      <h3>Total de Horas</h3>
      <canvas id="graficoHoras"></canvas>
  
  
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  import { Chart } from 'chart.js';
  
  export default {
    data() {
      return {
        proyectos: [], // Lista de proyectos evento
        selectedProyectoId: null, // Proyecto seleccionado
        datosTabla: {}, // Datos para la tabla
        chartCosto: null, // Gráfico de costos
        chartHoras: null, // Gráfico de horas
        clubActual: this.$store.getters.getClubActual,
      };
    },
    methods: {
      // Cargar proyectos disponibles
      async cargarProyectos() {
        try {
          const response = await axios.get('/api/proyectos',{
            params: {
              club_id: this.clubActual.id,
            },
          });
          this.proyectos = response.data;
  
          // Seleccionar el primer proyecto por defecto
          if (this.proyectos.length > 0) {
            this.selectedProyectoId = this.proyectos[0].id;
            this.cargarEstadisticas();
          }
        } catch (error) {
          console.error('Error al cargar los proyectos:', error);
        }
      },
      // Cargar estadísticas de tareas por mes y año
      async cargarEstadisticas() {
        if (this.selectedProyectoId) {
          try {
            const response = await axios.get(
              `/api/estadisticas/tareas/${this.selectedProyectoId}`
            );
            this.datosTabla = response.data;
            this.mostrarGraficos();
          } catch (error) {
            console.error('Error al cargar las estadísticas:', error);
          }
        }
      },
      // Mostrar los gráficos de barras separados
      mostrarGraficos() {
        // Preparar los datos para los gráficos
        const etiquetas = [];
        const costos = [];
        const horas = [];
  
        for (const anio in this.datosTabla) {
          for (const mes in this.datosTabla[anio]) {
            etiquetas.push(`${this.obtenerNombreMes(mes)} ${anio}`);
            costos.push(this.datosTabla[anio][mes].costo);
            horas.push(this.datosTabla[anio][mes].duracionHoras);
          }
        }
  
        // Mostrar gráfico de Costo Total
        if (this.chartCosto) {
          this.chartCosto.destroy(); // Destruir el gráfico anterior si ya existe
        }
  
        const ctxCosto = document?.getElementById('graficoCosto')?.getContext('2d');
        this.chartCosto = new Chart(ctxCosto, {
          type: 'bar',
          data: {
            labels: etiquetas,
            datasets: [
              {
                label: 'Costo Total',
                data: costos,
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
              },
            ],
          },
          options: {
            scales: {
              y: {
                beginAtZero: true,
              },
            },
          },
        });
  
        // Mostrar gráfico de Total de Horas
        if (this.chartHoras) {
          this.chartHoras.destroy(); // Destruir el gráfico anterior si ya existe
        }
  
        const ctxHoras = document.getElementById('graficoHoras').getContext('2d');
        this.chartHoras = new Chart(ctxHoras, {
          type: 'bar',
          data: {
            labels: etiquetas,
            datasets: [
              {
                label: 'Total de Horas',
                data: horas,
                backgroundColor: 'rgba(153, 102, 255, 0.2)',
                borderColor: 'rgba(153, 102, 255, 1)',
                borderWidth: 1,
              },
            ],
          },
          options: {
            scales: {
              y: {
                beginAtZero: true,
              },
            },
          },
        });
      },
      // Obtener el nombre del mes a partir del número del mes
      obtenerNombreMes(mes) {
        const meses = [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre',
        ];
        return meses[mes - 1];
      },
    },
    mounted() {
      this.cargarProyectos();
    },
  };
  </script>
  
  <style>
  .container {
    width: 80%;
    margin: 20px auto;
  }
  </style>
  